var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"grid-table",class:_vm.gridName ? 'grid-table__' + _vm.gridName : ''},[(!_vm.disabled)?_c('header',{staticClass:"grid-table-header grid-table-header__dark mb-1",class:_vm.headerClass},[_vm._t("header")],2):_vm._e(),(!_vm.disabled)?_vm._t("rows"):_c('ListEmptyWidget')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }